import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { aboutImages, scrollToId } from "@/config/business";
import { Reveal, Overline } from "@/components/Reveal";

export default function About() {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [0, reduce ? 0 : -40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, reduce ? 0 : 40]);

  return (
    <section id="about" ref={ref} className="py-20 md:py-32 bg-cream overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <Overline>About the Salon</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight text-ink">
            Your Local Beauty &amp; Grooming Studio
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground max-w-xl">
            At Lavniya Beauty Salon, beauty is personal. Whether you're booking a regular
            grooming appointment, refreshing your hair, preparing for an occasion or simply
            taking some time for yourself, our salon brings a range of beauty, hair and
            grooming services together in one convenient local destination.
          </p>
          <button
            data-testid="about-cta-button"
            onClick={() => scrollToId("contact")}
            className="mt-10 border border-primary text-primary px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-colors min-h-[48px]"
          >
            About the Salon
          </button>
        </Reveal>

        <div className="relative h-[440px] md:h-[560px]">
          <motion.div style={{ y: y1 }} className="absolute left-0 top-0 w-[70%]">
            <div className="overflow-hidden">
              <img
                src={aboutImages[0].src}
                alt={aboutImages[0].alt}
                loading="lazy"
                className="w-full h-[300px] md:h-[420px] object-cover"
                data-testid="about-image-primary"
              />
            </div>
          </motion.div>
          <motion.div style={{ y: y2 }} className="absolute right-0 bottom-0 w-[55%]">
            <div className="border-8 border-cream overflow-hidden shadow-[0_24px_60px_rgba(59,26,48,0.18)]">
              <img
                src={aboutImages[1].src}
                alt={aboutImages[1].alt}
                loading="lazy"
                className="w-full h-[220px] md:h-[300px] object-cover"
                data-testid="about-image-secondary"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
